import { z } from "zod";

const ZeptoWebhookDetailsSchema = z.record(z.string(), z.unknown());

const ZeptoWebhookEventDataSchema = z
  .object({
    details: z
      .union([
        ZeptoWebhookDetailsSchema,
        z.array(ZeptoWebhookDetailsSchema).min(1),
      ])
      .optional(),
  })
  .passthrough();

const ZeptoWebhookMessageSchema = z
  .object({
    email_info: z
      .object({
        client_reference: z.string().optional(),
        processed_time: z.union([z.string(), z.number()]).optional(),
      })
      .passthrough()
      .optional(),
    event_data: z
      .union([
        ZeptoWebhookEventDataSchema,
        z.array(ZeptoWebhookEventDataSchema).min(1),
      ])
      .optional(),
  })
  .passthrough();

export const ZeptoWebhookPayloadSchema = z
  .object({
    webhook_request_id: z.string().min(1),
    event_name: z.union([z.string(), z.array(z.string()).min(1)]),
    event_message: z.union([
      ZeptoWebhookMessageSchema,
      z.array(ZeptoWebhookMessageSchema).min(1),
    ]),
  })
  .passthrough();

export type ZeptoWebhookPayloadDto = z.infer<
  typeof ZeptoWebhookPayloadSchema
>;
